import React from 'react';
import DuaExplorer from '../components/dua_explorer/DuaExplorer';

const DuaExplorerPage = () => {
  return <DuaExplorer />;
};

export default DuaExplorerPage; 